<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                {{ $t("applications") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button v-if="flag==true" @click="back" class="p-button-danger" :label="$t('goback')" icon="pi pi-angle-double-left" />

              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="status_dropdownItems"
                    :value="status_dropdownItems._id"
                    :optionLabel="$t('langname')"
                    optionValue="_id"
                    filter
                    
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_applications") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            :header="$t('status')"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              
              <span>{{ data.application_status_name }}</span>
            </template>
          </Column>
          <Column :header="$t('application_no')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.application_no }}
            </template>
          </Column>
           <Column :header="$t('application_date')" style="min-width: 5rem">
            <template #body="{ data }">
              {{dateFormatDMY(data.date)  }}
            </template>
          </Column>
          <Column :header="$t('scheme_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.scheme_name }}
            </template>
          </Column>
         <Column :header="$t('applicant_name')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.applicant_name }}
            </template>
          </Column>
                    <Column :header="$t('applicant_mobile')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.mobile_no }}
            </template>
          </Column>
           <Column :header="$t('applicant_adhar')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.application_details?.adhar_no }}
            </template>
          </Column>
          <Column :header="$t('action')" headerStyle="min-width:5rem;">
            <template #body="slotProps">
              <Button
                icon="pi pi-eye"
                class="p-button-rounded p-button-warning"
                v-tooltip.bottom="$t('view')"
                @click="viewApplication(slotProps.data)"
              />
              
            </template>
          </Column>

        </DataTable>
      </div>
    </div>
   
   
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      flag:false,
     


      status_dropdownItems: [],
      status_dropdownItem: null,
      
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
      localInfo: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
    this.get_ApplicationStatusMaster();
  },
  async mounted() 
  {

    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    currentLocale() {

    },
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    async get_ApplicationStatusMaster() {
            
            var promise = apis.getApplicationStatusMaster({});
            promise.then((response) => {
                this.status_dropdownItems = response.data.data;
            });
        },
    viewApplication(product)
    {
      this.product = { ...product };
      this.product.FromPage = 'Application';
      localStorage.setItem("product", JSON.stringify(this.product));
      this.$router.push({ name: "ApplicationApproval"});
    },
    back() 
    {
            this.$router.push({
                name: "JobOpening",
            });
    },
    
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    async save_event() {
      if (!this.product.asset_type) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.asset_type_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_asset_type_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.rate_of_depreciation) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_rate_of_depreciation"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.remarks) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_remarks"),
          life: 3000,
        });
        return false;
      }
      if (!this.addeditstatus_dropdownItem) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_status"),
          life: 3000,
        });
        return false;
      }
      var details = {};
      if (this.product._id) {
        details = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          status: this.addeditstatus_dropdownItem?.value,
          lang: this.$i18n.locale,
        };
        var promise = apis.updateAssetType(details);
      } else {
        details = {
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          created_by: localStorage.getItem("id"),
          status: this.addeditstatus_dropdownItem?.value,
          client_id: localStorage.getItem("client_id"),
          lang: this.$i18n.locale,
        };
        var promise = apis.createAssetType(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
       
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        "client_id": localStorage.getItem("client_id"),
        "status": this.status_dropdownItem,
        "search": this.search_filter,
        "count": true,
        "mobile_no":this.mobile_no,
        "_id":""
        
      };
      this.loading = true;
      var promise = apis.schemeapplicationlist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        "client_id": localStorage.getItem("client_id"),
        "status": this.status_dropdownItem,
        "search": this.search_filter,
        "count": false,
        "page_no": this.page_no,
        "limit": this.limit,
        "mobile_no":this.mobile_no,
        "_id":""
        
        
      };
      this.loading = true;
      var promise = apis.schemeapplicationlist(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    
    
   
    deleteevent() {
      if (this.product._id) {
        var data = {
          _id: this.product._id,
          asset_type: this.product.asset_type,
          asset_type_mr: this.product.asset_type_mr,
          remarks: this.product.remarks,
          rate_of_depreciation: this.product.rate_of_depreciation.toString(),
          updated_by: localStorage.getItem("id"),
          status: 'Deleted',
          lang: this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.updateAssetType(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Asset Type");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  